import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { animateInfoButton, HelpModalIcon } from "./commons";
import { KModal, KModalSize, KModalVariant, tooltipate } from "../index";
import { animated, useSpring } from "@react-spring/web";
export const KCard = ({ className = "", id, helpModal, actions, header, children, fillHeight = false }) => {
    const key = `UIKIT_CARD_${id || "default"}_${window.location.pathname}_SHOWED`;
    const wasFirstTime = localStorage.getItem(key) !== "true";
    const [show, setShow] = useState(wasFirstTime);
    const [springs, api] = useSpring(() => ({
        from: { opacity: 1, scale: 1, color: "#8c9ab1", transformOrigin: "center center" },
    }));
    if (helpModal) {
        actions = [
            ...(actions || []),
            {
                element: tooltipate(_jsx(animated.i, { className: `${helpModal.icon ? helpModal.icon : HelpModalIcon.HELP}`, style: { ...springs } }), helpModal.tooltip, "left"),
                action: () => {
                    setShow(true);
                    if (helpModal.onShow) {
                        helpModal.onShow(true);
                    }
                },
            },
        ];
    }
    function closeEvent(dontPropagate = false) {
        setShow(false);
        if (helpModal && helpModal.onShow && !dontPropagate) {
            helpModal.onShow(false);
        }
        if (wasFirstTime && helpModal) {
            localStorage.setItem(key, "true");
            animateInfoButton(api);
        }
    }
    useEffect(() => {
        if ((helpModal === null || helpModal === void 0 ? void 0 : helpModal.show) === false) {
            closeEvent(true);
        }
    }, [helpModal === null || helpModal === void 0 ? void 0 : helpModal.show]);
    return (_jsxs(Card, { className: `text-center ${fillHeight ? "fillHeight" : ""} ${className}`, children: [header || actions ? (_jsxs(Card.Header, { children: [header || null, actions ? (_jsx("div", { className: "card-title-button-holder", children: _jsx("div", { children: actions.map((action, index) => (_jsx("a", { href: "/", onClick: async (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    await action.action();
                                }, children: action.element }, index))) }) })) : null] })) : null, fillHeight ? _jsx("div", { className: "card-body d-flex flex-column", children: children }) : _jsx(Card.Body, { children: children }), helpModal ? (_jsx(KModal, { show: helpModal.show === undefined ? show : helpModal.show, variant: helpModal.variant || KModalVariant.transparent, header: helpModal.header || _jsx(_Fragment, { children: "\u00A0" }), size: helpModal.size || KModalSize.xl, onHide: () => closeEvent(), footer: _jsx("div", {}), centered: helpModal.verticallyCentered, children: helpModal.content })) : null] }));
};
